import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_READ_CASES } from 'constants/urls';
import { CaseFilters } from './types';

/**
 * Fetches a paginated, filterable list of cases.
 * @param filters - Optional search/filter/pagination params
 * @returns The API response data (paginated case list)
 * @throws Re-throws any Axios error after logging
 */
const getCases = async (filters: CaseFilters = {}) => {
  const payload = {
    SearchKeyword: filters.SearchKeyword || '',
    Page: filters.Page || 1,
    Take: filters.Take || 1000,
    ...filters,
  };

  try {
    const { data } = await axiosInstance.get(
      `${URL_CANTRACK_READ_CASES}?payload=${JSON.stringify(payload)}`,
    );
    return data;
  } catch (error) {
    console.error('[getCases] Failed:', error);
    throw error;
  }
};

export default getCases;
